import { PLAN_STATUS } from '../../../features/vibe-coding/redux/constants';

const RESUMABLE_PLAN_STATUSES = new Set([
  PLAN_STATUS.EXECUTING,
  PLAN_STATUS.STOPPED,
  PLAN_STATUS.FAILED,
]);

const ACTIVE_PLAN_STATUSES = new Set([
  PLAN_STATUS.AWAITING_APPROVAL,
  ...RESUMABLE_PLAN_STATUSES,
]);

export const areMilestonesComplete = (milestones) =>
  Array.isArray(milestones) &&
  milestones.length > 0 &&
  milestones.every((step) => step.status === 'completed');

export const isPlanBuildComplete = (proposal, milestones = []) =>
  Boolean(proposal && proposal.status === PLAN_STATUS.COMPLETED) ||
  areMilestonesComplete(milestones);

export const normalizePlanProposal = (proposal) => {
  if (!proposal || typeof proposal !== 'object') return null;
  if (proposal.plan && typeof proposal.plan === 'object') return proposal;
  if (Array.isArray(proposal.tasks) || proposal.audience || Array.isArray(proposal.routes)) {
    const {
      tasks,
      audience,
      routes,
      userFlows,
      design,
      sharedLayout,
      dataDependencies,
      missingIntegrations,
      assets,
      acceptanceChecks,
      ...meta
    } = proposal;
    return {
      ...meta,
      status: meta.status || PLAN_STATUS.AWAITING_APPROVAL,
      plan: {
        tasks: tasks || [],
        audience,
        routes: routes || [],
        userFlows: userFlows || [],
        design,
        sharedLayout,
        dataDependencies,
        missingIntegrations,
        assets,
        acceptanceChecks,
      },
    };
  }
  return proposal;
};

export const isAwaitingPlanApproval = (proposal) =>
  Boolean(proposal && proposal.status === PLAN_STATUS.AWAITING_APPROVAL);

export const canResumeApprovedPlan = (proposal, milestones = []) => {
  if (isPlanBuildComplete(proposal, milestones)) return false;
  return Boolean(proposal && RESUMABLE_PLAN_STATUSES.has(proposal.status) && proposal.plan);
};

export const hasActivePlanProposal = (proposal) =>
  Boolean(proposal && ACTIVE_PLAN_STATUSES.has(proposal.status) && proposal.plan);

export const getPlanStatusLabel = (status) => {
  switch (status) {
    case PLAN_STATUS.AWAITING_APPROVAL:
      return 'Awaiting approval';
    case PLAN_STATUS.EXECUTING:
      return 'Approved';
    case PLAN_STATUS.STOPPED:
      return 'Paused';
    case PLAN_STATUS.FAILED:
      return 'Build interrupted';
    case PLAN_STATUS.COMPLETED:
      return 'Build complete';
    default:
      return null;
  }
};
